import { mergeModels, useModel, computed, resolveComponent, createBlock, openBlock, withCtx, createElementVNode, createElementBlock, createCommentVNode, createVNode, unref, createSlots, createTextVNode, toDisplayString } from "vue";
import { ROLES_LOOKUP } from "../../graphql/queries.js";
import { NavigationMenu } from "../../constants/NavigationMenu.js";
import "../../graphql/subscriptions.js";
import "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import "../../plugins/i18n.js";
import "../../assets/e94e4817134d7c25.png";
import "../../assets/5341da3ffbec0137.png";
import "../../assets/01f50022317dccd7.png";
import "axios";
import "vue-router";
import "maska";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
import "../../graphql/system-settings.js";
import "../../graphql/session-store.js";
import "vee-validate";
import "../../composables/useModalPage.js";
import "tiny-emitter/instance";
import "@iconify/vue";
import "../../icons/mdi/index.js";
import "../../icons/portal/index.js";
import "../../graphql/mutations.js";
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import { VCard } from "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css                     */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
/* empty css                               */
import "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import _sfc_main$1 from "../Icons/BanzaIconPicker.vue.js";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                          */
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                         */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                            */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                            */
/* empty css                    */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import BanzaSectionPicker from "../Base/BanzaSectionPicker.vue.js";
const _hoisted_1 = { class: "d-flex flex-wrap align-center g-4" };
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-wrap align-center g-4"
};
const _hoisted_3 = {
  key: 2,
  class: "d-flex flex-column g-2"
};
const _hoisted_4 = {
  key: 0,
  class: "banza-subtitle"
};
const _hoisted_5 = { class: "d-flex flex-wrap justify-space-between align-center g-4" };
const _sfc_main = {
  __name: "NavigationMenuEditCard",
  props: /* @__PURE__ */ mergeModels({
    usePages: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: []
    }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["onDelete"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {
    const item = useModel(__props, "modelValue");
    const isFavorite = computed(() => {
      var _a;
      return ((_a = item.value) == null ? void 0 : _a.id) === NavigationMenu.Favorite;
    });
    const isSystem = computed(() => {
      var _a;
      return !!((_a = item.value) == null ? void 0 : _a.isSystem);
    });
    const roles = computed({
      get() {
        var _a, _b, _c;
        return ((_c = (_b = (_a = item.value) == null ? void 0 : _a.roles) == null ? void 0 : _b.filter((c) => !c.isDeleted)) == null ? void 0 : _c.map((c) => {
          return {
            id: c.id,
            name: c.name
          };
        })) || [];
      },
      set(val) {
        var _a;
        let objValue = ((_a = item.value) == null ? void 0 : _a.roles) || [];
        if (objValue.length > 0) {
          const filteredValues = objValue.filter(
            (c) => c.id || !!val.find((cat) => (cat.name || cat) === c.name)
          );
          if (filteredValues.length < objValue.length) {
            objValue = filteredValues;
          }
          objValue.forEach((c) => {
            c.isDeleted = !val.find((cat) => cat.id === c.id);
          });
        }
        val.forEach((c) => {
          if (!objValue.find(
            (cat) => c.id && cat.id === c.id || (c.name || c) === cat.name
          )) {
            objValue.push({
              id: c.id,
              name: c.name || c,
              isDeleted: false
            });
          }
        });
        item.value.roles = objValue;
      }
    });
    const selectSection = (selectedItem) => {
      item.value.url = selectedItem.path;
      item.value.name = selectedItem.name;
    };
    return (_ctx, _cache) => {
      const _component_b_text_edit = resolveComponent("b-text-edit");
      const _component_b_switch = resolveComponent("b-switch");
      const _component_b_autocomplete = resolveComponent("b-autocomplete");
      const _component_b_btn = resolveComponent("b-btn");
      return openBlock(), createBlock(VCard, {
        class: "d-flex flex-column g-4 pa-6 rounded-xl",
        flat: ""
      }, {
        default: withCtx(() => {
          var _a, _b, _c;
          return [
            createElementVNode("div", _hoisted_1, [
              createVNode(unref(_sfc_main$1), {
                modelValue: item.value.icon,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => item.value.icon = $event),
                clearable: ""
              }, createSlots({ _: 2 }, [
                !item.value.icon ? {
                  name: "label",
                  fn: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.$t("base.labels.select_icon")), 1)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["modelValue"]),
              createVNode(_component_b_text_edit, {
                modelValue: item.value.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => item.value.name = $event),
                label: _ctx.$t("base.labels.name"),
                clearable: "",
                "multi-lingual": ""
              }, null, 8, ["modelValue", "label"])
            ]),
            !isSystem.value ? (openBlock(), createElementBlock("div", _hoisted_2, [
              createVNode(unref(BanzaSectionPicker), {
                "use-pages": __props.usePages,
                items: __props.items,
                onSelected: selectSection
              }, null, 8, ["use-pages", "items"]),
              createVNode(_component_b_text_edit, {
                modelValue: item.value.url,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => item.value.url = $event),
                label: "Url",
                clearable: ""
              }, null, 8, ["modelValue"])
            ])) : createCommentVNode("", true),
            !isSystem.value ? (openBlock(), createBlock(_component_b_switch, {
              key: 1,
              modelValue: item.value.isGroup,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => item.value.isGroup = $event),
              "hide-details": "",
              color: "primary",
              disabled: !!((_a = item.value.children) == null ? void 0 : _a.length),
              label: _ctx.$t("base.labels.group")
            }, null, 8, ["modelValue", "disabled", "label"])) : createCommentVNode("", true),
            !isFavorite.value ? (openBlock(), createElementBlock("div", _hoisted_3, [
              !((_c = (_b = item.value.roles) == null ? void 0 : _b.filter((r) => !r.isDeleted)) == null ? void 0 : _c.length) ? (openBlock(), createElementBlock("span", _hoisted_4, toDisplayString(_ctx.$t("base.messages.menu_roles_hint")), 1)) : createCommentVNode("", true),
              createVNode(_component_b_autocomplete, {
                modelValue: roles.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => roles.value = $event),
                label: _ctx.$t("base.labels.roles"),
                query: unref(ROLES_LOOKUP),
                "prepend-icon": "mdi-account-group",
                multiple: "",
                chips: "",
                "closable-chips": "",
                "select-mode": "",
                clearable: "",
                "items-result-path": "roles",
                color: "primary"
              }, null, 8, ["modelValue", "label", "query"])
            ])) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_5, [
              createVNode(_component_b_switch, {
                modelValue: item.value.isDeleted,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => item.value.isDeleted = $event),
                "hide-details": "",
                color: "primary",
                label: _ctx.$t("base.labels.hide")
              }, null, 8, ["modelValue", "label"]),
              !isSystem.value ? (openBlock(), createBlock(_component_b_btn, {
                key: 0,
                preset: "delete",
                onClick: _cache[6] || (_cache[6] = ($event) => _ctx.$emit("onDelete", item.value))
              })) : createCommentVNode("", true)
            ])
          ];
        }),
        _: 1
      });
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
